const data: any = {
  func: {
    list: [
      {
        mainTitle: "方案介绍",
        id: "plan_intro",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><strong>1.B2B2B合作模式1-自营分销</strong></p><p>1）京东作为供货方，为分销商服务商提供货源及配送服务；分销商服务商可在原有的服务能力上，接入京东，全面提升商品丰富度，减小库存、配送压力。下游分销商依旧由自己管理并扩展，分销商可在服务商的平台上进行正常交易。 </p><p>2）模式简图<br/></p><div class="media-wrap image-wrap"><img class="media-wrap image-wrap" src="https://img10.360buyimg.com/imagetools/s900x573_jfs/t1/144023/36/19779/101343/5fe335afE10040776/07ffae07d0b28b20.png!q60"/></div><p><span style="font-size:16px"><strong>2.B2B2B合作模式2-自营托盘</strong><br/>1）京东东作为供货方，将定价权托给品牌操盘，品牌可建立自己的分销商，进行分货； 分销商服务商可在原有的服务能力上，接入京东，全面提升商品丰富度，减小库存、配送压力。下游分销商依旧由自己管理并扩展，分销商可在服务商的平台上进行正常交易。 </span></p><p><span style="font-size:16px">2）模式简图</span><br/></p><div class="media-wrap image-wrap"><img class="media-wrap image-wrap" src="https://img14.360buyimg.com/imagetools/s900x581_jfs/t1/139842/27/19953/126431/5fe3446fE83aab6a1/cbf4e74e08d4fa30.png!q60"/></div><p></p><p></p><p></p>',
            picture: "",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "业务流程",
        id: "access_type",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph: "",
            picture:
              "//img11.360buyimg.com/imagetools/s900x600_jfs/t1/151795/26/11338/94639/5fe47d82Ef964918d/6e910e5aec04d5bd.png!q80",
            showPicture: true,
          },
          { subTitle: "", paragraph: "", picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", showPicture: false },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "系统对接",
        id: "access_type",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px">京东提供商品、物流、订单、财务系统的各类对外接口，保证业务的正向进行；服务商需要接入京东接口，并对自身系统进行一定程度改造。<br/></span></p><div class="media-wrap image-wrap"><img src="https://img12.360buyimg.com/imagetools/s900x570_jfs/t1/151706/38/11126/21326/5fe34580E8e94f1b0/7fbe7253c7944d5d.png!q80" alt=""/></div><p><span style="font-size:16px">1.先与商务确认需要接入哪种模式 </span></p><p><span style="font-size:16px">2.京东接口均发布在统一对外开放平台宙斯平台上，在确认需要对接后，将准备使用的京东商城账号发给商务，申请接口后商务需联系宙斯同事审核接口。 </span></p><p><span style="font-size:16px">3.在正式开发前，需要先注册一个京东商城账号（如已有，可使用旧账号），注册地址 https://www.jd.com </span></p><p><span style="font-size:16px">4.注册完成后，商城账号登录，开通成为宙斯开放平台开发者，进入宙斯【控制台】-【创建应用】-【其他业务】-【B2B应用】申请应用。申请应用时可不入驻云鼎（云鼎为京东云服务），相关信息务必填写使用完整，（因接口中会校验pin，一个模式需要一个单独的京东商城pin） </span></p><p><span style="font-size:16px">5.token生成需要做Bpin特殊转换处理。需要联系对应的业务对接人员和宙斯平台进行申请。 </span></p><p><span style="font-size:16px">6.申请接口调用权限，联系京东侧运营人员申请接口权限 http://xbp.jd.com/22/apply/3059，审核通过后下载对应接口的SDK包 </span></p><p><span style="font-size:16px">7.以上若遇到审核过程较慢，可反馈给商务侧或对接群加急。</span></p><p></p><p></p>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "调用方法",
        id: "ability",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px">1.开发文档：https://jos.jd.com/commondoc?listId=3、https://jos.jd.com/commondoc?listId=323， </span></p><p><span style="font-size:16px">2.常见错误码：https://jos.jd.com/commondoc?listId=171</span></p>',
            picture:
              "//img13.360buyimg.com/imagetools/s600x720_jfs/t1/153934/12/11185/36255/5fe34a9eE648e0c36/3ffa8c616f713fda.png!q80",
            showPicture: true,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "相关权限包",
        id: "permission_package",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="color:#393939"><span style="background-color:#fafafa"><strong><span style="font-size:16px">B2B2B合作模式1-自营分销</span></strong></span></span></p><p><span style="font-size:16px">1\t获取商品详情：jingdong.b2b.ware.detail.get \t</span></p><p><span style="font-size:16px">2\t价格查询：jingdong.b2b.promotion.price.get\t </span></p><p><span style="font-size:16px">3\t库存查询：jingdong.b2b.product.stock.get\t </span></p><p><span style="font-size:16px">4\t查询运费：jingdong.b2b.freight.get \t </span></p><p><span style="font-size:16px">5\t提交采购单：jingdong.b2b.open.PoCenterProvider.submitPo\t </span></p><p><span style="font-size:16px">6\t采购单反查：jingdong.b2b.po.PoMidProvider.backCheck  \t </span></p><p><span style="font-size:16px">7\t采购单列表：jingdong.b2b.po.PoMidProvider.queryPurOrders   \t </span></p><p><span style="font-size:16px">8\t查询订单详情：jingdong.b2b.gxpt.purchaseOrderErpService.findErpOrder \t </span></p><p><span style="font-size:16px">9\t订单列表： jingdong.b2b.mid.OrderMiddleProvider.queryOrderList   \t </span></p><p><span style="font-size:16px">10\t物流查询接口：jingdong.b2b.order.logistics.get \t </span></p><p><span style="font-size:16px">11\t生成汇款识别码：jingdong.b2b.payment.B2bPayClient.b2bPayReq\t </span></p><p><span style="font-size:16px">12\tSN码查询：jingdong.b2b.aftersales.sn.get  </span></p><p><span style="font-size:16px">13\t消息获取：jingdong.b2b.message.get  \t </span></p><p><span style="font-size:16px">14\t消息删除：jingdong.b2b.message.delete  \t </span></p><p><span style="font-size:16px">15    获取省级地址列表： jingdong.areas.province.get </span></p><p><span style="font-size:16px">16    获取区县级信息列表： jingdong.areas.county.get </span></p><p><span style="font-size:16px">17    获取乡镇级信息列表： jingdong.areas.town.get </span></p><p><span style="font-size:16px">18    中小件COD： jingdong.zxj.cod.get</span></p><p></p><p><span style="font-size:16px"><strong>B2B2B合作模式2-自营托盘</strong><br/>1 查询商品池ID ：jingdong.b2b.ware.queryUserToPool </span></p><p><span style="font-size:16px">2 查询商品列表 ：jingdong.b2b.ware.search.skulist.tuopan </span></p><p><span style="font-size:16px">3 价格查询 ：jingdong.b2b.promotion.price.get </span></p><p><span style="font-size:16px">4 查询商品详情 ：jingdong.b2b.ware.detail.get </span></p><p><span style="font-size:16px">5 商品大字段： jingdong.b2b.product.getBigField </span></p><p><span style="font-size:16px">6 库存查询 ：jingdong.b2b.stock.batchGetAreaStock  </span></p><p><span style="font-size:16px">7 提交采购单： jingdong.b2b.open.PoCenterProvider.submitPo </span></p><p><span style="font-size:16px">8 批量查询采购单： jingdong.b2b.po.PoMidProvider.queryPurOrders  </span></p><p><span style="font-size:16px">9 查询订单详情-支持批量 ：jingdong.b2b.order.childOrderList </span></p><p><span style="font-size:16px">10 查询采购单详情： jingdong.b2b.po.PoMidProvider.queryPurOrderDetail       </span></p><p><span style="font-size:16px">11 生成汇款识别码 ：jingdong.b2b.payment.B2bPayClient.b2bPayReq     </span></p><p><span style="font-size:16px">12 物流查询接口 ：jingdong.b2b.order.logistics.get      </span></p><p><span style="font-size:16px">13 消息查询： jingdong.b2b.message.get      </span></p><p><span style="font-size:16px">14 消息删除： jingdong.b2b.message.delete      </span></p><p><span style="font-size:16px">15 获取省级地址列表： jingdong.areas.province.get </span></p><p><span style="font-size:16px">16 获取区县级信息列表： jingdong.areas.county.get </span></p><p><span style="font-size:16px">17 获取乡镇级信息列表 ：jingdong.areas.town.get </span></p><p><span style="font-size:16px">18 中小件COD： jingdong.zxj.cod.get</span></p><p></p><p></p>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [
          { text: "", link: "" },
          { text: "", link: "" },
        ],
        tableData: [
          {
            columns: [
              { title: "序号", width: 100 },
              { title: "名称", width: 200 },
              { title: "场景介绍", width: 300 },
            ],
          },
        ],
        figure: [
          {
            picture:
              "//img10.360buyimg.com/imagetools/s920x1120_jfs/t1/135650/3/12828/231942/5f8e10f3E7fb99a75/baeea00e24cf4cca.jpg!q80",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/196x196?fs=20&t=196*196PX" }],
          },
        ],
        links: [
          {
            logo:
              "//img12.360buyimg.com/imagetools/s500x485_jfs/t1/130630/13/13050/143508/5f8e1191Ebfc4c0d9/a71f75a28ab02049.png!q80",
            text: "",
            link: "",
          },
        ],
      },
      {
        mainTitle: "注意事项",
        id: "success_case",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px">1.下单给京东时商品售价为非必传（提单时发现价格为空则自动补全京东采购价，若有价格则校验是否与京东采购价是否一致）、第三方订单号（poReq.thirdOrderId）；托盘必须传产品线ID、SKUID；</span></p><p><span style="font-size:16px">2.会出现库存不足等导致的运营人员进行多次拆单情况，需要多次查询使得每个商品都拆分完毕。一个采购单可反查出全部已拆分采购单。</span></p><p><span style="font-size:16px">3.采购单有可能会被品牌方修改价格和数量。 </span></p><p><span style="font-size:16px">4.采购单转订单后，可查每个采购单对应的订单号，订单号会因为库存在不同仓库等原因再次拆分。</span></p><p><span style="font-size:16px">5.第三方采购单号与京东采购单、订单对应关系为： 1）一个第三方采购单—&gt;多个京东采购单 2）单个京东采购单—&gt;多个京东子订单 3）一个京东子订单—&gt;一个物流单号 </span></p><p><span style="font-size:16px">6.下单时不用传入运费，因采购单下单后京东可以会拆单，运费在拆单后由京东补齐，拆单后单个订单单价小于99元收运费； </span></p><p><span style="font-size:16px">7.下采购单时需要确认订单支付时使用的支付方式，目前仅支持一单一种支付方式；（支付方式枚举值：在线支付-3、对公转账-5、承兑汇票-18、承兑余额（开发中，枚举值后续同步）-（承兑支付需要联系商务给每个子账户开通，否则付款时无法使用该方式））； </span></p><p><span style="font-size:16px">8.托盘和自营分销完全独立</span></p>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "常见问题",
        id: "common_question",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph: "",
            picture:
              "//img12.360buyimg.com/imagetools/s240x148_jfs/t1/151253/29/3674/143508/5f8e1235Ea0a3b9dc/2a90ac63531f85a5.png!q80",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture:
              "//img13.360buyimg.com/imagetools/s196x148_jfs/t1/128259/13/15563/143508/5f8e1273Ea59a37b3/3e8225be107477bd.png!q80",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [
          {
            logo:
              "//img13.360buyimg.com/imagetools/s84x66_jfs/t1/127157/37/12870/885/5f631425Ec9674444/8ef5161d0d75878a.png!q80",
            text: "如何获取权限",
            link: "https://jos.jd.com/commondoc?listId=170",
          },
          {
            logo:
              "//img13.360buyimg.com/imagetools/s84x66_jfs/t1/127157/37/12870/885/5f631425Ec9674444/8ef5161d0d75878a.png!q80",
            text: "如何调用API",
            link: "https://jos.jd.com/commondoc?listId=33",
          },
        ],
      },
    ],
    navIcon:
      "//img12.360buyimg.com/imagetools/s30x30_jfs/t1/141550/14/8792/466/5f631ba3Ed46c7e5b/e72428abbb315b90.png!q80",
  },
  style: {},
  data: {
    perm_list: {
      type: "remote",
      config: {
        id: 7,
        url: "//joshome.jd.com/perm/list",
        method: "GET",
        headers: null,
        options: null,
        dataName: "perm_pack_list",
        reqParams: { cateId: { title: "分类id", scope: "url", name: "cateId", value: "" } },
        dynamicParams: {},
        filter: "return data;",
        dataRoute: "",
        pathname: "/perm/list",
      },
      data: {
        code: 0,
        success: true,
        data: [
          {
            permPackageId: 581,
            permPackageName: "会员营销基础包",
            permPackageDesc: "会员营销基础包",
            permPackageType: 1,
            permPackageStatus: 0,
            permPackageApproveDesc: null,
          },
          {
            permPackageId: 582,
            permPackageName: "会员营销高级包",
            permPackageDesc: "会员营销高级包",
            permPackageType: 2,
            permPackageStatus: 0,
            permPackageApproveDesc: null,
          },
        ],
      },
      localFilter: "return data;",
    },
  },
  _clstag_: "jdzeus_b2b2b_zeus_solution_ability_detail",
};
export default data;
